module.exports = __webpack_public_path__ + "static/media/BMODE_a2e4b387-de76-404d-853d-bf2fed557406.9d1f9197.jpg";